import { ds } from "js/core/models/dataService";
import { app } from "js/namespaces";
import { FeatureType } from "common/features";
import { UpgradePlanDialogType } from "js/react/views/MarketingDialogs/UpgradePlanDialog";
import { trackActivity } from "js/core/utilities/utilities";
import { ShowDialog } from "js/react/components/Dialogs/BaseDialog";
import ExportDialog from "js/react/views/PresentationSettings/dialogs/ExportDialog";
import { getStaticUrl } from "js/config";

export function getPresentationMenu() {
    const workspaceId = ds.selection.presentation.getWorkspaceId();

    let items = [];

    if (ds.selection.presentation.get("isTemplate")) {
        items.push({
            icon: "list",
            value: "exit_template_editor",
            label: "Exit Template Editor"
        });
    } else {
        items.push({
            icon: "list",
            value: "go_to_library",
            label: "Return to Library"
        });
        items.push({
            type: "divider"
        });

        items.push({
            icon: "share",
            value: "share_presentation",
            label: "Sharing Settings"
        });

        items.push({
            icon: "person_add_alt_1",
            value: "collab_presentation",
            label: "Collaboration"
        });

        items.push({
            icon: "play_circle_outline",
            value: "player_settings",
            label: "Player Settings",
            showProBadge: !app.user.features.isFeatureEnabled(FeatureType.PLAYER_SETTINGS, ds.selection.presentation.getWorkspaceId()),
            upgradeType: UpgradePlanDialogType.UPGRADE_PLAN,
            proBadgeAnalytics: { cta: "Player Settings", ...ds.selection.presentation.getAnalytics() },
            proBadgeWorkspaceId: ds.selection.presentation.getWorkspaceId(),
        });

        items.push({
            icon: "show_chart",
            value: "analytics",
            label: "View Analytics",
            showProBadge: !app.user.features.isFeatureEnabled(FeatureType.ANALYTICS, ds.selection.presentation.getWorkspaceId()),
            upgradeType: UpgradePlanDialogType.UPGRADE_PLAN,
            proBadgeAnalytics: { cta: "analytics", ...ds.selection.presentation.getAnalytics() },
            proBadgeWorkspaceId: ds.selection.presentation.getWorkspaceId(),
        });

        items.push({
            type: "divider"
        });

        items.push({
            icon: "history",
            value: "recover",
            label: "Recover Deleted Slides"
        });

        items.push({
            type: "divider"
        });

        items.push({
            icon: "cloud_download",
            value: "export",
            label: "Export Presentation..."
        });

        items.push({
            icon: "print",
            value: "print",
            label: "Print Presentation..."
        });
    }

    return {
        overwriteTriggerHandler: true,
        items,
        callback: async action => {
            switch (action) {
                case "go_to_library":
                    trackActivity("Editor", "Exit");
                    app.router.navigate("/", { trigger: true });
                    break;
                case "exit_template_editor":
                    app.appState.setLibraryLocation({ type: "team-resources", pane: "templates" });
                    app.router.navigate("/", { trigger: true });
                    break;
                case "share_presentation":
                    app.mainView.editorView.showPresentationSettings("share");
                    break;
                case "collab_presentation":
                    app.mainView.editorView.showPresentationSettings("collaborate");
                    break;
                case "export":
                    ShowDialog(ExportDialog, { presentation: ds.selection.presentation });
                    break;
                case "player_settings":
                    app.mainView.editorView.showPresentationSettings("player-settings");
                    break;
                case "analytics":
                    app.mainView.editorView.showPresentationSettings("analytics");
                    break;
                case "print":
                    ds.selection.presentation.printToPDF();
                    break;
                case "offline":
                    app.mainView.editorView.showPresentationSettings("export");
                    break;
                case "recover":
                    app.mainView.editorView.showPresentationSettings("version-history");
                    break;
            }
        }
    };
}
